import * as pc from 'playcanvas';

export const loadAssets = (app, sku_id, bgUrl, setProgress, galleryFile = null, carFile = null, modelConfig = null, status = null, original = false, testingConfig = null) => {
    const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;

    return new Promise((resolve) => {
        const segmentedCarUrl =
            testingConfig?.segmented_car ?
                testingConfig?.segmented_car :
                `${process.env.REACT_APP_CLOUD_FRONT_URL}/processed/${sku_id}/point_cloud.ply`;
     
        const originalCarUrl = 
            testingConfig?.full_scene ? 
                testingConfig?.full_scene :
                `${process.env.REACT_APP_CLOUD_FRONT_URL}/processed/${sku_id}/point_cloud.ply`

        const shadow_caster_url = 
            testingConfig?.mesh ? 
                testingConfig?.mesh :
                `${process.env.REACT_APP_CLOUD_FRONT_URL}/processed/${sku_id}/mesh.glb`;


        const assets = {
            shadow_caster: new pc.Asset('shadow_caster', 'container', { url: shadow_caster_url }),
        };

        // Handle gallery asset
        if (galleryFile) {
            assets.gallery = new pc.Asset('gallery', 'container', { url: URL.createObjectURL(galleryFile) });
        } else if (bgUrl) {
            assets.gallery = new pc.Asset('gallery', 'container', { url: bgUrl });
        }

        let carUrl;
        if (original) {
            carUrl = originalCarUrl;
        } else {
            carUrl = segmentedCarUrl;
        }

        // Handle car asset
        if (carFile) {
            assets.car = new pc.Asset('gsplat', 'gsplat', { url: URL.createObjectURL(carFile) });
        } else {
            assets.car = new pc.Asset('gsplat', 'gsplat', { url: carUrl });
        }

        const totalAssets = Object.keys(assets).length;
        let loadedAssets = 0;

        const updateProgress = () => {
            loadedAssets++;
            const percentage = (loadedAssets / totalAssets) * 100;
            setProgress(percentage);
        };

        Object.values(assets).forEach(asset => {
            asset.once('load', () => {
                updateProgress();
                if (loadedAssets === totalAssets) {
                    resolve(assets);
                }
            });

            asset.once('error', (err) => {
                console.error('Asset loading error:', err);
                updateProgress();
                if (loadedAssets === totalAssets) {
                    resolve(assets);
                }
            });
        });

        const assetListLoader = new pc.AssetListLoader(Object.values(assets), app.assets);
        assetListLoader.load(() => resolve(assets));
    });
};
